"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import GooglePlacesAutocomplete from "../get-a-quote/GooglePlacesAutocomplete/index";

export default function GetInstantQuote() {
  const [zip, setZip] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [branchID, setBranchID] = useState(null); // State to store BranchID
  const [address, setAddress] = useState(null); // State to store BranchID
  const router = useRouter();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Reset any previous error

    if (!zip) {
      setError("Please enter a valid zipcode.");
      return;
    }

    setIsLoading(true);
    window.location.href = `https://signup.poop911.com/signup/step1?address=${encodeURI(
      address
    )}`;

    return;
    try {
      const response = await fetch(`/api/zipcode?zip=${zip}`);

      if (!response.ok) {
        const data = await response.json();
        setError(
          data.error || `Sorry, we do not service this zipcode (${zip}).`
        );
        return;
      }

      const data = await response.json();
      // console.log("API Response Data:", data); // Debug log

      // Extract BranchID and store it
      const branchID = data.BranchID;
      setBranchID(branchID);

      // Redirect to form page with the zip and branchID query parameters
      // window.location.href = `/get-a-quote?zip=${zip}&branchID=${branchID}`;

      window.location.href = `https://signup.poop911.com/signup/step1?address=${encodeURI(
        address
      )}`;
      setIsLoading(false);
    } catch (err) {
      console.error("Fetch Error:", err);
      setError(err.message || "An error occurred. Please try again later.");
      setIsLoading(false);
    }
  };

  return (
    <div className="relative max-w-full px-4 z-50">
      <div className="container relative py-4 md:py-8 -top-16 shadow-lg rounded-2xl bg-brandLight text-center">
        <h3 className="text-xl uppercase font-semibold mb-2 font-jost">
          Free initial cleanup with regular service
        </h3>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col md:flex-row items-center justify-center gap-4"
        >
          <div className="w-full md:w-[20rem] min-h-[48px]">
            {/* Autocomplete input */}
            <GooglePlacesAutocomplete
              onPlaceSelected={(place) => {
                const addressComponents = place.address_components;
                const zipCode =
                  addressComponents.find((c) => c.types.includes("postal_code"))
                    ?.long_name || "";
                setAddress(place.formatted_address);
                setZip(zipCode);
                setBranchID(addressComponents);
              }}
              className="w-full text-lg rounded-full border border-gray-300 px-4 py-2"
              placeholder="Enter your address here"
              setZipCode={setZip}
              setAddress={setAddress}
            />
          </div>

          <button
            type="submit"
            className="bg-[#cb243a] rounded-full border px-4 md:px-8 text-white uppercase py-2 disabled:opacity-50 transition-all duration-200"
            disabled={isLoading}
          >
            Get Instant Quote
          </button>
        </form>

        {error && <div className="text-red-500 mt-2">{error}</div>}
      </div>
    </div>
  );
}
